export const VEHICLE_CATEGORY_COLLECTION_PATH = '/config/tenant/vehicleCategory';
export const VEHICLE_TYPE_COLLECTION_PATH = '/config/tenant/vehicleCategory/1001/vehicleType';
export const getVehicleTypeCollectionPath = (vehicleCategoryId) => `/config/tenant/vehicleCategory/${vehicleCategoryId}/vehicleType`;
export const BOOKINGS_COLLECTION_PATH = '/booking';
export const CHAUFFEUR_COLLECTION_PATH = '/chauffeur';